import * as React from "react";
const SvgRequirements24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 22,
        fill: "black",
        viewBox: "0 0 18 22"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M4.17 4H2v16h14V4h-2.17A3.001 3.001 0 0 1 11 6H7a3.001 3.001 0 0 1-2.83-2Zm9.66-2H18v20H0V2h4.17A3.001 3.001 0 0 1 7 0h4c1.306 0 2.418.835 2.83 2ZM6 3a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Zm8 13H4v-2h10v2ZM4 12h10v-2H4v2Z",
      clipRule: "evenodd"
    })
  );
export default SvgRequirements24Px;
